/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { useEffect, useState } from "react";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";

// Images
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";
import team4 from "assets/images/team-4.jpg";
import DataTable from "examples/Tables/DataTable";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Icon,
  Menu,
  Switch,
} from "@mui/material";
import applicator from "ajv/dist/vocabularies/applicator";
import colors from "assets/theme/base/colors";
import { useNavigate } from "react-router-dom";
import NotificationItem from "examples/Items/NotificationItem";
import MDButton from "components/MDButton";
import { updateBannerSequence } from "api";
import { deleteBanner } from "api";
import { notify } from "utilities";

export default function data({ data, isMyProfile = true, onPressAddBanner, onReloadBanner }) {
  const navigate = useNavigate();
  const [list, setList] = useState(data);
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [currentRowId, setCurrentRowId] = useState(null);

  const [openConfirm, setOpenConfirm] = useState(false);

  useEffect(() => {
    if (list?.length > 1) {
      updateBannerSequenceApi();
    }
  }, [list]);

  const handleAction = (event, rowId) => {
    setMenuAnchor(event.currentTarget);
    setCurrentRowId(rowId);
  };

  const closeMenu = () => {
    setMenuAnchor(null);
    // setCurrentRowId(null);
  };

  const columns = () => {
    return [
      { Header: "#", accessor: "number", width: "5%", align: "left" },
      { Header: "name", accessor: "name", width: "60%", align: "left" },
      {
        Header: "sequence",
        accessor: "sequence",
        width: "20%",
        align: "center",
      },
      {
        Header: "actions",
        accessor: "actions",
        width: "10%",
        align: "center",
      },
    ];
  };

  const oneEditClick = () => {
    closeMenu();
  };
  const onDeleteClick = () => {
    // Implement delete functionality here
    closeMenu();
    setOpenConfirm(true);
  };

  const handleDelete = () => {
    deleteBannerApi();
  };

  const deleteBannerApi = () => {
    var params = {};

    deleteBanner({
      params: params,
      id: currentRowId,
    })
      .then((responseJson) => {
        if (responseJson) {
          if (responseJson?.status === 400) {
          } else {
            notify();
            onReloadBanner && onReloadBanner();
          }
        }
      })
      .catch((e) => {});
  };

  const renderActionMenu = (rowId) => (
    <Menu
      id={`simple-menu-${rowId}`}
      anchorEl={menuAnchor}
      anchorReference={null}
      anchorOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      open={Boolean(menuAnchor) && currentRowId === rowId}
      onClose={closeMenu}
      sx={{ mt: 2 }}
    >
      {/* <NotificationItem icon={<Icon>mode_edit</Icon>} title="Edit" onClick={oneEditClick} /> */}
      <NotificationItem
        icon={<Icon>delete</Icon>}
        title={
          <>
            <span style={{ color: "red" }}>Delete</span>
          </>
        }
        onClick={onDeleteClick}
      />
    </Menu>
  );

  const confirmDialog = () => {
    return (
      <Dialog open={openConfirm} onClose={() => setOpenConfirm(false)}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          Are you sure you want to delete this banner? This action cannot be undone.
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirm(false)} color="error" variant="contained">
            Cancel
          </Button>
          <MDButton onClick={handleDelete} color="error">
            Delete
          </MDButton>
        </DialogActions>
      </Dialog>
    );
  };

  const moveItem = (index, direction) => {
    const updatedItems = [...list];
    if (direction === "up" && index > 0) {
      [updatedItems[index - 1], updatedItems[index]] = [
        updatedItems[index],
        updatedItems[index - 1],
      ];
    } else if (direction === "down" && index < list.length - 1) {
      [updatedItems[index], updatedItems[index + 1]] = [
        updatedItems[index + 1],
        updatedItems[index],
      ];
    }
    setList(updatedItems);
  };

  const updateBannerSequenceApi = () => {
    var params = {
      ids: list.map((i) => i?._id),
    };

    updateBannerSequence({
      params: params,
    })
      .then((responseJson) => {
        if (responseJson) {
          if (responseJson?.status === 400) {
          } else {
          }
        }
      })
      .catch((e) => {});
  };

  const rows = () => {
    var rowsData = [];

    list.map((item, index) =>
      rowsData.push({
        number: (
          <MDBox display="flex" alignItems="center">
            <MDTypography variant="caption">{index + 1}</MDTypography>
          </MDBox>
        ),
        name: (
          <MDBox display="flex" gap={2}>
            <MDAvatar
              src={item?.imageUrl || ""}
              size="sm"
              sx={{
                width: "75px", // optional: control size
                height: "75px", // optional: control size
                borderRadius: 0,
              }}
            />
          </MDBox>
        ),
        sequence: (
          <MDBox alignItems="center" display="flex" flexDirection="column" gap={0.5}>
            <MDButton
              p={0}
              variant="gradient"
              color={index === 0 ? "light" : "success"}
              size="small"
              onClick={() => index !== 0 && moveItem(index, "up")}
              iconOnly
              circular
            >
              <Icon>arrow_upward_rounded</Icon>
            </MDButton>

            <MDButton
              p={0}
              variant="gradient"
              color={index === list.length - 1 ? "light" : "success"}
              size="small"
              onClick={() => index !== list.length - 1 && moveItem(index, "down")}
              iconOnly
              circular
            >
              <Icon>arrow_downward_rounded</Icon>
            </MDButton>

            {/* <MDTypography
              // display="block"
              component="a"
              variant="caption"
              color="light"
              fontWeight="medium"
              sx={{
                cursor: "pointer",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: index === 0 ? "grey.500" : "success.main",
                borderRadius: "12px",
                //   padding: "6px 6px",
                transition: "background-color 0.3s ease",
                "&:hover": {
                  backgroundColor: index === 0 ? "grey.500" : "success.focus",
                },
              }}
              onClick={() => index !== 0 && moveItem(index, "up")}
            >
              <Icon fontSize="medium">arrow_drop_up</Icon>
            </MDTypography> */}
            {/* <MDTypography
              component="a"
              variant="caption"
              color="light"
              fontWeight="medium"
              sx={{
                cursor: "pointer",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: index === list.length - 1 ? "grey.500" : "success.main",
                borderRadius: "12px",
                transition: "background-color 0.3s ease",
                "&:hover": {
                  backgroundColor: index === list.length - 1 ? "grey.500" : "success.focus",
                },
              }}
              onClick={() => index !== list.length - 1 && moveItem(index, "down")}
            >
              <Icon fontSize="medium">arrow_downward_rounded</Icon>
            </MDTypography> */}
          </MDBox>
        ),
        actions: (
          <MDBox onClick={(e) => handleAction(e, item?._id)}>
            <MDTypography
              component="a"
              variant="caption"
              color="secondary"
              fontWeight="medium"
              sx={{ cursor: "pointer" }}
            >
              <Icon fontSize="small">more_vert</Icon>
            </MDTypography>
          </MDBox>
        ),
      })
    );

    return rowsData;
  };

  const onPressAdd = () => {
    onPressAddBanner && onPressAddBanner();
  };

  return (
    <MDBox>
      <DataTable
        table={{ columns: columns(), rows: rows() }}
        isSorted={false}
        entriesPerPage={false}
        showTotalEntries={true}
        canSearch={false}
        noEndBorder
        canAdd={{
          onClick: onPressAdd,
          label: "Add",
        }}
      />
      {list.map((item) => renderActionMenu(item?._id))}
      {/* {renderActionMenu()} */}
      {confirmDialog()}
    </MDBox>
  );
}
